/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Payments_AmountInputs */

const en_settings_payments_amount = /** @type {(inputs: Settings_Payments_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount`)
};

/**
* | output |
* | --- |
* | "Amount" |
*
* @param {Settings_Payments_AmountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_payments_amount = /** @type {((inputs?: Settings_Payments_AmountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Payments_AmountInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_payments_amount(inputs)
});
export { settings_payments_amount as "settings.payments.amount" }